import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ServiceBookService } from '../../../services/serviceBook.service';
import { SERIVCEBOOK_MODULE_NAMESPACE, SERVICEBOOK_GET_SERVICEBOOK } from '../../../store/service-book';
import { IServiceBookDetails } from '../../../store/service-book/service-book-state.store';


const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)
@Component({
  name:'ServiceBookTickets',
  components: {

  }
})
class ServiceBookEquipments extends Vue {


  @ServiceBookStore.Getter isLoading: boolean;
  @ServiceBookStore.Getter currentServiceBook:IServiceBookDetails

  @ServiceBookStore.Action(SERVICEBOOK_GET_SERVICEBOOK)
  storeGetServiceBook: (id:string) => void

  constructor() {
    super();
  }

  beforeMount()
  {
    const id = this.$route.params.id
    this.storeGetServiceBook(id)
  }


}

export default ServiceBookEquipments;



// WEBPACK FOOTER //
// ./src/containers/service-book/equipments_UNUSED/index.ts